
import { ShippingOptionResponse } from "../../Models/Shipping";
import { getShippingMethodLabel } from "../../Utils/Enums";
import { formatPriceBRL, formatDeliveryTime } from "../../Utils/DataFormatters";
import { FaTimes } from "react-icons/fa";
import Modal from "../Modal/Modal";

interface ShippingAndDeliveryModalProps {
  isOpen: boolean;
  onClose: () => void;
  shippingOptions: ShippingOptionResponse[] | null;
};

const ShippingAndDeliveryModal: React.FC<ShippingAndDeliveryModalProps> = ({
  isOpen,
  onClose,
  shippingOptions,
}) => {

  if (!isOpen || shippingOptions === null) {
    return null;
  }

  return (
    <Modal
      overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4"
      onClose={onClose}
      closeOnEsc
      closeOnBackdropClick
    >
      {/* Same width as the payment modal on phones; wider from sm, where the table replaces the cards */}
      <div className="bg-white rounded-md max-w-sm sm:max-w-xl w-full px-4 md:px-6 py-4 md:py-6 relative">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          <FaTimes />
        </button>

        <h2 className="text-lg font-bold mb-4 text-center">{"Frete e Prazo"}</h2>

        {/* MOBILE CARDS */}
        <div className="flex flex-col gap-3 sm:hidden">
          {shippingOptions.length === 0 ? (
            <p className="text-center text-gray-500 py-3">{"Nenhuma opção de frete disponível para o CEP informado."}</p>
          ) : shippingOptions.map((option, index) => {
            const label = getShippingMethodLabel(option.methodType);
            const priceLabel =
              option.price === 0
                ? "Grátis"
                : option.price != null
                ? formatPriceBRL(option.price)
                : "A definir";

            const deliveryLabel = formatDeliveryTime(option.deliveryTime);

            return (
              <div key={index} className="border rounded p-3 shadow-sm">
                <p className="font-semibold">{label}</p>
                <p>{priceLabel}</p>
                <p>{deliveryLabel}</p>
              </div>
            );
          })}
        </div>

        {/* DESKTOP TABLE */}
        <table className="hidden sm:table w-full table-auto border border-gray-200">
          <thead>
            <tr className="bg-primary-120 text-left">
              <th className="px-4 py-2 border-b">{"Forma de envio"}</th>
              <th className="px-4 py-2 border-b">{"Valor"}</th>
              <th className="px-4 py-2 border-b">{"Prazo"}</th>
            </tr>
          </thead>
          <tbody>
            {shippingOptions.length === 0 ? (
              <tr>
                <td className="px-4 py-3 text-center text-gray-500" colSpan={3}>{"Nenhuma opção de frete disponível para o CEP informado."}</td>
              </tr>
            ) : shippingOptions.map((option, index) => {
              const label = getShippingMethodLabel(option.methodType);
              const priceLabel =
                option.price === 0
                  ? "Grátis"
                  : option.price != null
                  ? formatPriceBRL(option.price)
                  : "A definir";
              const deliveryLabel = formatDeliveryTime(option.deliveryTime);

              return (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{label}</td>
                  <td className="px-4 py-2 border-b font-semibold">{priceLabel}</td>
                  <td className="px-4 py-2 border-b">{deliveryLabel}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default ShippingAndDeliveryModal;
